const homewords ={
    'titulo':{
        'es':'Casos de estudio',
        'en':'Case Studies'},
    'Diseño UX/UI':{
        'es':'Diseño UX/UI',
        'en':'UX/UI Design'},
    'Gráfica':{
        'es':'Gráfica',
        'en':'Graphic Design'},
}

export default homewords;